import { render, staticRenderFns } from "./gongZiMingXi.vue?vue&type=template&id=52013142&scoped=true&"
import script from "./gongZiMingXi.vue?vue&type=script&lang=js&"
export * from "./gongZiMingXi.vue?vue&type=script&lang=js&"
import style0 from "./gongZiMingXi.vue?vue&type=style&index=0&id=52013142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52013142",
  null
  
)

export default component.exports